import React, { useState, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { lang } from "../lang";
import { createTask } from "../utils/taskUtils"; // Added this import

// Component for bulk task input
function BulkTaskInput({ onAddTask, parentId, title, defaultTaskDuration }) {
  const [inputValue, setInputValue] = useState("");
  const isProcessingRef = useRef(false);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() && !isProcessingRef.current) {
      e.stopPropagation(); // Prevent any other Enter key actions
      isProcessingRef.current = true;
      const taskNames = inputValue
        .split(",")
        .map((name) => name.trim())
        .filter((name) => name);

      taskNames.forEach((name) => {
        // Use createTask to ensure all defaults, including priority (null by default), are set
        const newTaskData = createTask(
          {
            name,
            // duration and remaining will be handled by createTask using defaultTaskDuration
          },
          defaultTaskDuration
        );

        // createTask already assigns a UUID, so we use the one it generates.
        // We ensure 'isNew' is true for focusing.
        const taskToAdd = { ...newTaskData, isNew: true };

        if (process.env.NODE_ENV === "development") {
          console.log(
            `[BulkTaskInput] Adding task to ${
              title || (parentId ? `parent ${parentId}` : "Main Tasks")
            }:`,
            taskToAdd,
            "parentId:",
            parentId
          );
        }
        onAddTask(parentId, taskToAdd);
      });
      setInputValue("");
      setTimeout(() => {
        isProcessingRef.current = false;
      }, 100); // Reset processing flag after a short delay
    }
  };

  return (
    <input
      type="text"
      className="bulk-task-input"
      value={inputValue}
      onChange={handleInputChange}
      onKeyDown={handleInputKeyDown}
      placeholder={lang.taskColumn.bulkTaskInputPlaceholder}
      onClick={(e) => e.stopPropagation()} // Prevent clicks from bubbling to task selection
    />
  );
}

export default BulkTaskInput;
